import {
  Grid2 as Grid,
  Tab,
  Tabs,
  Container,
  Button,
} from "@mui/material";
import { Navigate, useNavigate } from "react-router-dom";

import ServiceLine from "./ServiceLine";
import { useOrgConfig } from "~/providers/OrgConfigProvider";
import { useState } from "react";
import CreateServiceLineDialog from "./CreateServiceLineDialog";

interface TabServiceLinesProps {
  id?: number;
}

const TabServiceLines = ({ id }: TabServiceLinesProps) => {
  const { serviceLines } = useOrgConfig();
  const navigate = useNavigate();
  const [createDialogOpen, setCreateDialogOpen] = useState(false);

  const tab = id;
  if (!tab) {
    const serviceLineId = Object.values(serviceLines)[0]?.id;
    if (serviceLineId) {
      return <Navigate to={`/operate-config/service-lines/${serviceLineId}`} replace />;
    }
  }

  return <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 4, lg: 3, xl: 2}}>
        <Tabs
          value={tab}
          onChange={(_, newValue) => { navigate(`/operate-config/service-lines/${newValue}`); }}
          orientation="vertical"
          variant="scrollable"
          sx={{ maxHeight: 400 }}
          visibleScrollbar={true}
        >
          {Object.values(serviceLines).map((sl) => sl && <Tab key={sl.id} label={sl.name} value={sl.id} />)}
        </Tabs>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setCreateDialogOpen(true)}
          sx={{ mt: 2, width: "100%" }}
        >
          Create Service Line
        </Button>

        <CreateServiceLineDialog
          open={createDialogOpen}
          onClose={() => setCreateDialogOpen(false)}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 8, lg: 9, xl: 10 }}>
        {tab && serviceLines[tab] && <ServiceLine key={tab} serviceLineId={tab} />}
      </Grid>
    </Grid>
  </Container>
}

export default TabServiceLines;
